import { isEmpty } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import { Navigate, redirect, useRouteLoaderData } from 'react-router-dom';
import { useAuth } from './providers/auth';

export const redirectToLogin = () => {
  let redirectUrl = '/login'
  return redirect(redirectUrl)
}

export default function AuthManager(props) {
  const { children } = props;
  const { user } = useRouteLoaderData('Root');
  const { isPageLoading } = useAuth();

  let authenticated = !isEmpty(user);
  // // todo: need to remove the line below
  // // marked statically for now, use the presence of user to find authenticated status
  // authenticated = true;

  if (isPageLoading) {
    return (
      <div className="loading-screen">
        Loading...
      </div>
    );
  }


  if (!authenticated) return <Navigate to="/login" replace />
  return children
}

AuthManager.propTypes = {
  children: PropTypes.element,
}
